export const MEDIA_GALLERY_LIST_REQUEST = 'MEDIA_GALLERY/LIST_REQUEST'
export const MEDIA_GALLERY_LIST_RESPONSE = 'MEDIA_GALLERY/LIST_RESPONSE'
export const MEDIA_GALLERY_LIST_DONE = 'MEDIA_GALLERY/LIST_DONE'
export const MEDIA_GALLERY_LIST_RESET = 'MEDIA_GALLERY/LIST_RESET'
